// ABOUTME: Status banner component for subscription card with 8 state-specific designs
// ABOUTME: Displays emoji, title, subtitle, and contextual information with Material UI Alert

import React from 'react';
import { Alert, AlertTitle, Box, Typography } from '@mui/material';
import { SubscriptionInfo } from './types';
import { getSubscriptionBannerConfig } from './subscriptionBannerUtils';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';

interface SubscriptionStatusBannerProps {
  subscriptionInfo: SubscriptionInfo;
}

const SubscriptionStatusBanner: React.FC<SubscriptionStatusBannerProps> = ({ subscriptionInfo }) => {
  const config = getSubscriptionBannerConfig(subscriptionInfo);
  const showAutoRenewIcon = ['active', 'cancelled'].includes(subscriptionInfo.status.toLowerCase());

  return (
    <Alert severity={config.color} icon={false} sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ flex: 1 }}>
          <AlertTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0 }}>
            <span>{config.emoji}</span>
            <span>{config.title}</span>
          </AlertTitle>
          {config.subtitle && (
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              {config.subtitle}
            </Typography>
          )}
          {config.context && config.context.length > 0 && (
            <Box sx={{ mt: 1 }}>
              {config.context.map((line, idx) => (
                <Typography key={idx} variant="body2">
                  {line}
                </Typography>
              ))}
            </Box>
          )}
        </Box>
        {showAutoRenewIcon && (
          <Box sx={{ ml: 2 }}>
            {subscriptionInfo.hasAutoRenew ? (
              <AutorenewIcon titleAccess="Auto-renew ON" sx={{ fontSize: 28 }} />
            ) : (
              <PauseCircleOutlineIcon titleAccess="Auto-renew OFF" sx={{ fontSize: 28 }} />
            )}
          </Box>
        )}
      </Box>
    </Alert>
  );
};

export default SubscriptionStatusBanner;
